export interface NewUnCodeModel {
    code: string;
    name: string;
    imdgClass: string;
    status: UnCodeStatusModel
}

export interface UnCodeModel {
    id: string;
    status: UnCodeStatusModel;
    code: string;
    name: string;
    imdgClass: string;
}

export interface UnCodeModelForDropdown {
    id: string;
    code: string;
    name: string;
}

export enum UnCodeStatusModel {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}
